import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NbButtonModule, NbCardModule, NbDialogRef, NbToastrService } from '@nebular/theme';
import { TurmaCatequizandoDto } from '../../../core/api/turma-catequizando.dto';
import { Turma } from '../../../core/api/turma';
import { TurmaCatequizandoService } from '../../../core/api/turma-catequizando.service';
import { TurmaService } from '../../../core/api/turma.service';
import { finalize } from 'rxjs';
import { AutocompleteComponent, OpcaoAutocomplete } from '../../../shared/autocomplete/autocomplete.component';
import { mensagemDeErro } from '../../../utils/mensagem-erro';

@Component({
  selector: 'app-transferir-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, NbCardModule, NbButtonModule, AutocompleteComponent],
  templateUrl: './transferir-dialog.component.html',
  styleUrl: './transferir-dialog.component.scss',
})
export class TransferirDialogComponent implements OnInit {
  @Input() matricula!: TurmaCatequizandoDto;

  turmas: Turma[] = [];
  turmaEntradaId = '';
  salvando = false;
  carregandoTurmas = false;

  get opcoesTurma(): OpcaoAutocomplete[] {
    return this.turmas.map((t) => ({ id: t.id ?? '', rotulo: this.labelTurma(t) }));
  }

  labelTurma(t: Turma): string {
    const nome = (t.nome ?? '').trim();
    return t.ano != null ? `${nome} (${t.ano})` : nome;
  }

  constructor(
    private turmaService: TurmaService,
    private matriculaService: TurmaCatequizandoService,
    private toastr: NbToastrService,
    protected ref: NbDialogRef<TransferirDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.buscarTurmas('');
  }

  /**
   * `FRM-04` — busca no servidor. Antes carregava as 500 primeiras e filtrava em memória; a
   * turma de destino 501 simplesmente não existia para quem estava transferindo.
   */
  buscarTurmas(termo: string): void {
    this.carregandoTurmas = true;
    this.turmaService
      .listar(0, 20, termo)
      .pipe(finalize(() => (this.carregandoTurmas = false)))
      .subscribe({
        next: (res) => {
          // A turma de origem não é destino válido.
          this.turmas = (res.content ?? []).filter((t) => t.id !== this.matricula.turmaId);
        },
      });
  }

  salvar(): void {
    if (!this.turmaEntradaId || !this.matricula) return;
    this.salvando = true;
    this.matriculaService
      .transferir({
        turmaSaida: this.matricula.turmaId,
        turmaEntrada: this.turmaEntradaId,
        pessoa: this.matricula.pessoaId,
      })
      .subscribe({
        next: () => {
          this.salvando = false;
          this.ref.close(true);
        },
        // A transferência falhava calada: o diálogo ficava aberto sem dizer nada.
        error: (err) => {
          this.salvando = false;
          this.toastr.danger(mensagemDeErro(err, 'Não foi possível transferir.'), 'Erro');
        },
      });
  }

  fechar(): void {
    this.ref.close(false);
  }
}
